export default __webpack_public_path__ + "static/media/Group1165.514de460.svg";